import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { getStartDateForSchoolYear } from 'Src/helpers/calendar/calendar';
import { getDefaultReportAgesForMultiSelect, getReportDefaultGendersForMultiSelect } from 'Src/helpers/multiselect/multiselect';
import { UnionSchoolReportForm } from '../UnionSchoolReportForm';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; }
export function UnionSchoolClubsReportForm({ onCloseClick, onSubmit }: Props) {
  const now = new Date();
  return <UnionSchoolReportForm
    initialValues={{ dateFrom: getStartDateForSchoolYear(now), dateTo: now, ageGroups: getDefaultReportAgesForMultiSelect(), genders: getReportDefaultGendersForMultiSelect(), isShowInactive: true, isShowBlank: true, isSelectAllAges: true }}
    reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_SCHOOL_CLUBS}
    description="Create a union-wide directory of extracurricular clubs for the selected period and audience."
    toggles={[
      { field: 'isShowInactive', label: 'Include inactive clubs', hint: 'Show clubs that were inactive during the reporting period.' },
      { field: 'isShowBlank', label: 'Include schools with no clubs', hint: 'Keep schools with no matching clubs in the report.' }
    ]}
    onCloseClick={onCloseClick} onSubmit={onSubmit}
  />;
}
